import PropTypes from "prop-types";

import PaymentTypeHandler from "Giving/ManageMyGivingPage/PaymentTypeHandler";

import FnrButton from "UI/FnrButton3";

import {
  PopoverBorder,
  PopoverButtonsContainer,
  PopoverContent,
  PopoverMessage,
  PopoverTitle,
} from "./styles";

StoppedContent.propTypes = {
  paymentType: PropTypes.string,
  nextPaymentDate: PropTypes.string,
  handleClose: PropTypes.func,
  openEditModal: PropTypes.func,
};

export default function StoppedContent({
  paymentType,
  nextPaymentDate,
  handleClose,
  openEditModal,
}) {
  const paymentTypeHandler = new PaymentTypeHandler(paymentType);

  return (
    <PopoverContent>
      <PopoverTitle>{paymentTypeHandler.plural()} Stopped</PopoverTitle>
      <PopoverBorder />
      <PopoverMessage>
        This recurring {paymentType} is currently stopped due to{" "}
        <strong>multiple failed payment attempts</strong>.
        <br />
        <br />
        Your next {paymentType} is scheduled for{" "}
        <strong>{nextPaymentDate}</strong>.
        <br />
        <br />
        Click the button below to update your payment method or resume your
        recurring {paymentType}.
      </PopoverMessage>
      <PopoverButtonsContainer>
        <FnrButton onClick={handleClose} size="small">
          Cancel
        </FnrButton>
        <FnrButton color="blue" onClick={openEditModal} size="small">
          Update {paymentTypeHandler.capitalized()}
        </FnrButton>
      </PopoverButtonsContainer>
    </PopoverContent>
  );
}
